import { Theme } from '@infotech-soe/erp-ui-kit';
import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(({ colors }: Theme) => ({
  '@global': {
    '.dataset-title': {
      overflow: 'hidden',
    },
    '.active-panel:focus, .active-panel:focus-within': {
      borderColor: 'var(--primary)',
      '& .dataset-title, & .dataset-toolbar': {
        backgroundColor: colors.backgroundPanelActive,
        fontWeight: 'bold',
      },
    },
  },
  title: {
    composes: ['dataset-title', 'no-wrap'],
    whiteSpace: 'nowrap',
  },
  treeTitle: {
    composes: ['dataset-title', 'no-wrap'],
    whiteSpace: 'nowrap',
    borderBottom: `1px solid ${colors.borderDivider}`,
  },
}));
